import { useEffect, useState } from 'react'
import QRCode from 'react-qr-code'
import { useParams } from 'react-router-dom'

import { Flex, Icon, Spinner, Text, useToast } from '@chakra-ui/react'

import { ReactComponent as SuccessIcon } from '../../components/assets/icons/Subtract.svg'
import { ReactComponent as ButtonIcon } from '../../components/assets/icons/Union.svg'
import MainButton from '../../components/Button/MainButton'
import PixCard from '../../components/card/PixCard'
import TextCounter from '../../components/counter/TextCounter'
import Header from '../../components/header/Header'
import MainText from '../../components/header/MainText'
import { API_URL } from '../../components/helpers/Helpers'
import Wrapper from '../../components/wrapper/Wrapper'

type IRegularizationData = {
  qrcode: string
  price: number
  createdAt: string
  paymentStatus: string
}

const RegularizarPix = () => {
  const { qrcodeKey } = useParams()
  const toast = useToast()
  const [regularizationData, setRegularizationData] = useState<IRegularizationData>({
    qrcode: '',
    price: 0,
    createdAt: '',
    paymentStatus: '',
  })
  const [isPaid, setIsPaid] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  const copy = () => {
    if (regularizationData?.qrcode) {
      if (navigator.userAgent.indexOf('Safari') === -1) {
        try {
          navigator.clipboard.write([
            new ClipboardItem({
              'text/text': Promise.resolve(regularizationData.qrcode).then((result) => {
                if (!result) {
                  return new Blob([``])
                }

                return new Blob([regularizationData.qrcode])
              }),
            }),
          ])
        } catch (error) {
          console.error(error)
        }
        toast({
          position: 'bottom',
          render: () => (
            <Flex
              justify="center"
              align="center"
              bg="#4bb543"
              direction="column"
              fontSize="15px"
              p="5px"
              pb="8px"
              borderRadius="15px"
              color="white"
            >
              <Text>Código copiado!</Text>
              <Text mx="5px">Abra o App do seu banco e efetue o pagamento.</Text>
            </Flex>
          ),
        })
      } else {
        toast({
          position: 'bottom',
          render: () => (
            <Flex
              justify="center"
              align="center"
              bg="#4bb543"
              direction="column"
              fontSize="15px"
              p="5px"
              pb="8px"
              borderRadius="15px"
              color="white"
            >
              <Text>Código copiado!</Text>
              <Text mx="5px">Abra o App do seu banco e efetue o pagamento.</Text>
            </Flex>
          ),
        })
        try {
          navigator.clipboard.writeText(regularizationData?.qrcode)
        } catch (error) {
          console.error(error)
        }
      }
    }
  }

  useEffect(() => {
    fetch(`${API_URL}/api/acts/invoices/id/${qrcodeKey}`)
      .then((res) => res.json())
      .then(({ data }) => {
        if (data.paid_at) {
          setIsPaid(true)
        }
        addRegularizationData(data)
      })
      .finally(() => setIsLoading(false))
  }, [qrcodeKey])

  useEffect(() => {
    if (qrcodeKey) {
      const timer = setInterval(() => {
        fetch(`${API_URL}/api/acts/invoices/id/${qrcodeKey}`)
          .then((res) => res.json())
          .then(({ data }) => {
            if (data.paid_at) {
              setIsPaid(true)
              clearInterval(timer)
            }
          })
      }, 5000)
      return () => clearInterval(timer)
    }
  }, [qrcodeKey])

  const addRegularizationData = (data: any) => {
    setRegularizationData({
      qrcode: data.transaction?.Key || '',
      price: data.price || 0,
      createdAt: data.created_at || '',
      paymentStatus: data.payment_status || '',
    })
  }

  return (
    <>
      {isLoading ? (
        <Wrapper>
          <Spinner size={'lg'} />
        </Wrapper>
      ) : isPaid ? (
        <Wrapper>
          <Header />
          <Flex w="100%" align="center" gap="10px">
            <Icon h="40px" w="40px" as={SuccessIcon} />
            <Flex direction="column">
              <Text fontSize="20px" fontWeight="700">
                Recebemos o pagamento!
              </Text>
              <Text fontSize="15px" fontWeight="400">
                Agora é só seguir tranquilo.
              </Text>
            </Flex>
          </Flex>
          <Flex direction="column" w="100%" bg="white" borderRadius="15px">
            <Flex
              w="100%"
              h="100%"
              direction="column"
              bg="white"
              borderRadius="15px"
              boxShadow="0px 0px 50px rgba(0, 52, 127, 0.1)"
            >
              <Flex
                w="100%"
                justify="space-between"
                borderBottomWidth="3px"
                borderColor="rgba(221, 228, 241, 0.5)"
                p="20px"
                fontSize="20px"
                fontWeight="500"
              >
                <Text>Total</Text>
                <Text>R$ {regularizationData?.price ? (regularizationData.price / 100).toFixed(2) : '0,00'}</Text>
              </Flex>
            </Flex>
          </Flex>
        </Wrapper>
      ) : (
        <Wrapper>
          <Header />
          <MainText text="Agora é só você efetuar o pagamento da regularização!" />
          <PixCard>
            <QRCode size={256} value={regularizationData?.qrcode} />
          </PixCard>
          <Flex w="100%" overflowX="hidden">
            {' '}
          </Flex>
          <MainButton type="button" text="Copiar código do QR Code" icon={ButtonIcon} onClick={copy} />
          <TextCounter createdAt={regularizationData.createdAt} />
          <Flex
            w="100%"
            h="100%"
            direction="column"
            bg="white"
            borderRadius="15px"
            boxShadow="0px 0px 50px rgba(0, 52, 127, 0.1)"
          >
            <Flex
              w="100%"
              justify="space-between"
              borderBottomWidth="3px"
              borderColor="rgba(221, 228, 241, 0.5)"
              p="20px"
              fontSize="20px"
              fontWeight="500"
            >
              <Text>Total</Text>
              <Text>R$ {regularizationData?.price ? (regularizationData.price / 100).toFixed(2) : '0,00'}</Text>
            </Flex>
          </Flex>
        </Wrapper>
      )}
    </>
  )
}

export default RegularizarPix
